import component from "./TrailerDescription";
export default component;
